export default function validate(props) {
  const { values, errors } = props;
  if (!values.contentType) errors.contentType = "You Must Specify a Catalog";

  return props;
}
